import React, {Component} from "react"
import PropTypes from "prop-types"

import History from "@irati/utils/history"
import {H2, Body, Label} from "@irati/ui/src/Typography"
import Button from "@irati/ui/src/Button"
import {FormattedMessage} from "@irati/utils/lang"
import Flex from "@irati/ui/src/Flex"
import {RouterLink} from "@irati/ui/src/Link"
import Spacing from "@irati/ui/src/Spacing"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import theme from "@irati/ui/src/global/theme"
import workosService from "@irati/workos/services/workos"
import authentication from "@irati/auth"

import Help from "../Help"
import BackToIntegration from "../BackToIntegration"
import EnabledDisabledLabel from "../EnabledDisabledLabel"
import {SETTINGS_LOGIN_INTEGRATION, SETTINGS_LOGIN_INTEGRATION_CHECKLIST_DSYNC} from "../../../../routes/routeConfig"
import {PeopleDirectoryImage} from "../../../../images/index"
import {InfoCard} from "../styled"
import GenerateWorkOSLinks from "../GenerateWorkOSLinks"

interface Props {}

interface State {
  load: Promise<void> | null,
  enabled: boolean
}

class PeopleDirectory extends Component<Props, State> {
  state: State = {
    load: null,
    enabled: false
  }
  static contextTypes = {
    appPath: PropTypes.string
  }

  componentDidMount() {
    workosService.getOrganisation(authentication.business().uuid).then((organisation) => {
      this.setState({enabled: organisation?.organisationId && organisation?.directoryId})
    })
  }

  redirectToDirectorySyncLink = () => {
    const load = workosService.generatePortalLinks(authentication.business().uuid).then((portalLinks) => {
      if (portalLinks?.directorySyncUrl) {
        window.location = portalLinks.directorySyncUrl
      }
    })
    this.setState({load})
  }

  onClickBack = () => {
    History.push({
      pathname: `${SETTINGS_LOGIN_INTEGRATION}`}, this.context)
  }

  render() {
    const {enabled, load} = this.state

    return <>
      <BackToIntegration onClick={this.onClickBack} />
      <Flex>
        <Spacing marginRight={7}>
          <Flex marginBottom={1} alignItems="center">
            <H2 marginTop={1} marginBottom={1} marginRight={1}>
              <FormattedMessage id="admin.components.integration.directorySync.title" />
            </H2>
            <EnabledDisabledLabel enabled={enabled} />
          </Flex>
          <Body marginBottom={4}>
            <FormattedMessage id="admin.components.integration.directorySync.text" />
          </Body>
          <Flex marginBottom={1}>
            <RouterLink cta to={SETTINGS_LOGIN_INTEGRATION_CHECKLIST_DSYNC}>
              <FormattedMessage id="admin.components.integration.directorySync.checklistPageLink" />
            </RouterLink>
            <Icon icon={IconTypes.arrowRight} color={theme.colors.primary1} marginLeft={theme.spacing.one} />
          </Flex>
        </Spacing>
        <PeopleDirectoryImage />
      </Flex>
      <Spacing marginBottom={7} />
      <InfoCard padding={2} marginBottom={4}>
        <Flex>
          <Spacing>
            <Icon icon={IconTypes.info} size={20} />
          </Spacing>
          <Body marginLeft={1}>
            <FormattedMessage
              id="admin.components.integration.directorySync.linkHint"
              values={{immediately: <Label large weight="bold">
                <FormattedMessage id="admin.components.integration.directorySync.linkHintBoldWord" />
              </Label>}} />
          </Body>
        </Flex>
      </InfoCard>
      <Button load={load} onClick={this.redirectToDirectorySyncLink} primary>
        {enabled
          ? <FormattedMessage id="admin.components.integration.directorySync.button.edit" />
          : <FormattedMessage id="admin.components.integration.directorySync.button.enable" />
        }
      </Button>
      <GenerateWorkOSLinks isDisabled={enabled} />
      <Help />
    </>
  }
}

export default PeopleDirectory
